
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { i18n } from "@/i18n";
import { ISolCustomerSupply } from "@/entities";
import IconTrash from "@/components/common/icon/IconTrash.vue";

@Component({
  name: "supplies-table",
  components: {
    IconTrash,
  },
})
export default class SuppliesTable extends Vue {
  @Prop({ required: false, default: null }) supplies!: ISolCustomerSupply[];
  @Prop({ required: false, default: false }) readonly!: boolean;

  constructor() {
    super();
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "commodityTypeDescription",
        label: i18n.t("label.commodityType") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first table-cell-middle align-middle",
      },
      {
        key: "commodityDescription",
        label: i18n.t("label.commodity") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "quantity",
        label: i18n.t("label.quantity") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last",
      },
    ];
  }

  removeSupply(index: number): void {
    this.supplies.splice(index, 1);
  }
}
